// utils/bootCounters.ts — Permanent instrumentation that pins the
// SPA "one-shot" contract. Counters MUST stay at 1 for the life of
// the tab; any drift past 1 means we re-mounted the shell, re-init'd
// auth, or re-init'd Firebase - which is exactly what the React/SPA
// rebuild was supposed to eliminate.
//
// Exposed on window so Playwright can read it. No telemetry; the
// numbers stay client-side.

declare global {
  interface Window {
    __bootCounters?: BootCounters;
  }
}

export interface BootCounters {
  appBoot: number;
  firebaseInit: number;
  authInit: number;
  layoutMount: number;
  routerStart: number;
}

const initial: BootCounters = {
  appBoot: 0,
  firebaseInit: 0,
  authInit: 0,
  layoutMount: 0,
  routerStart: 0,
};

// Initialise on module load. main.tsx imports this exactly once.
if (typeof window !== 'undefined') {
  if (!window.__bootCounters) {
    window.__bootCounters = { ...initial };
  }
  window.__bootCounters.appBoot += 1;
}

export function bump(key: keyof BootCounters): void {
  if (typeof window === 'undefined') return;
  if (!window.__bootCounters) window.__bootCounters = { ...initial };
  window.__bootCounters[key] += 1;
}

export function read(): BootCounters {
  if (typeof window === 'undefined' || !window.__bootCounters) {
    return { ...initial };
  }
  return { ...window.__bootCounters };
}
